<template>
    <section class="lymphomap_main">
        <div class="lbil_admin_list_wrp">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="main_heading">
                            <button type="button" class="btn back_btn" tapable @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>MEDICAL MACHINE LEARNING
                        </h2>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <div class="all_user_list_wrp">
                            <carousel :mouseDrag="false" :touchDrag="false" :autoplay="false" :loop="false" :nav="false"
                                :margin="15" :dots="false" :items="4"
                                :responsive="{ 0: { items: 1 }, 1024: { items: 4 }, 1900: { items: 6 } }" v-once>
                                <template slot="prev"><span class="all_users_slider_arrow member_slider_prev"><i
                                            class="fa fa-angle-left" aria-hidden="true"></i></span></template>
                                <div class="carousel_item">
                                    <div class="total_count_box active">
                                        <div class="count_icon">
                                            <span class="filter_cat_img_box">
                                                <img src="@/assets/images/filter_icon/ai_list.png" class="img-fluid"
                                                    style="width:42px;">
                                            </span>
                                        </div>
                                        <div class="count_title_w_n">
                                            <span class="count_title">
                                                <div class="global_filter_name_in_html">Models</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel_item">
                                    <router-link :to="{ name: 'AiModelsCreated' }">
                                        <div class="total_count_box">
                                            <div class="count_icon">
                                                <span class="filter_cat_img_box">
                                                    <img src="@/assets/images/filter_icon/ai_create.png"
                                                        class="img-fluid" style="width:42px;">
                                                </span>
                                            </div>
                                            <div class="count_title_w_n">
                                                <span class="count_title">
                                                    <div class="global_filter_name_in_html">Create Model</div>
                                                </span>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="carousel_item">
                                    <div class="total_count_box" @click="userFiltersInfoPopupMethod('models_history')">
                                        <div class="count_icon">
                                            <span class="filter_cat_img_box">
                                                <img src="@/assets/images/filter_icon/ai_histories.png"
                                                    class="img-fluid" style="width:42px;">
                                            </span>
                                        </div>
                                        <div class="count_title_w_n">
                                            <span class="count_title">
                                                <div class="global_filter_name_in_html">History</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="carousel_item">
                                    <div class="total_count_box">
                                        <div class="count_icon">
                                            <span class="filter_cat_img_box">
                                                <img src="@/assets/images/filter_icon/toturials.png" class="img-fluid"
                                                    style="width:42px;">
                                            </span>
                                        </div>
                                        <div class="count_title_w_n">
                                            <span class="count_title">
                                                <div class="global_filter_name_in_html">Tutorials</div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <template slot="next"><span class="all_users_slider_arrow member_slider_next"><i class="fa fa-angle-right" aria-hidden="true"></i></span></template> -->
                            </carousel>
                        </div>
                    </div>
                </div>
                <!-- User Filters Tab List -->
                <div class="filter_cat_box_list">
                    <div class="filter_cat_box_list_inner">
                        <div class="filter_cat_box_tabs">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="user_filters_list_item"
                                        @click="userFiltersInfoPopupMethod('public_models')">
                                        <div class="user_filters_item_info">
                                            <div class="user_filters_wrp">
                                                <span class="user_filters_title">Public Models</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="user_filters_list_item"
                                        @click="userFiltersInfoPopupMethod('shared_models')">
                                        <div class="user_filters_item_info">
                                            <div class="user_filters_wrp">
                                                <span class="user_filters_title">Shared Models</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="user_filters_list_item"
                                        @click="userFiltersInfoPopupMethod('created_models')">
                                        <div class="user_filters_item_info">
                                            <div class="user_filters_wrp">
                                                <span class="user_filters_title">My Created Models</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="user_filters_list_item"
                                        @click="userFiltersInfoPopupMethod('recently_used_models')">
                                        <div class="user_filters_item_info">
                                            <div class="user_filters_wrp">
                                                <span class="user_filters_title">Recently Used Models</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- User Filters Tab Info Popup -->
            <div class="user_filters_info_popup_main" v-if="userFilterInfoPopupState">
                <div class="user_filters_info_popup" :class="userFilterInfoPopupStateClass ? 'active' : ''">
                    <div class="user_filters_info_modal">
                        <div class="user_filters_info_modal_center">
                            <div class="user_filters_info_inner">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h2 class="user_filters_info-heading">
                                            <template v-if="userFilterInfoData == 'created_models'">
                                                <h2 class="user_filters_info-heading">My Created Models</h2>
                                            </template>
                                            <template v-else-if="userFilterInfoData == 'public_models'">
                                                <h2 class="user_filters_info-heading">Public Models</h2>
                                            </template>
                                            <template v-else-if="userFilterInfoData == 'recently_used_models'">
                                                <h2 class="user_filters_info-heading">Recently Used Models</h2>
                                            </template>
                                            <template v-else-if="userFilterInfoData == 'shared_models'">
                                                <h2 class="user_filters_info-heading">Shared Models</h2>
                                            </template>
                                            <template v-else-if="userFilterInfoData == 'models_history'">
                                                <h2 class="user_filters_info-heading pt-2">History of Prediction</h2>
                                            </template>
                                            <h6 v-if="userFilterInfoData == 'models_history'" class="filter_subheading">
                                                Here is your
                                                record on predictions you have made for single patients</h6>
                                        </h2>
                                    </div>
                                    <div class="col-auto text-right">
                                        <div class="user_filters_info_close">
                                            <span class="user_filters_info_close_span"><i aria-hidden="true"
                                                    class="fa fa-times-circle" @click="clickedOutside"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="user_filters_info_content pt-3">
                                    <div class="container-fluid">
                                        <template v-if="userFilterInfoData == 'created_models'">
                                            <created-models></created-models>
                                        </template>
                                        <template v-else-if="userFilterInfoData == 'public_models'">
                                            <public-models></public-models>
                                        </template>
                                        <template v-else-if="userFilterInfoData == 'recently_used_models'">
                                            <recently-used-Models></recently-used-Models>
                                        </template>
                                        <template v-else-if="userFilterInfoData == 'shared_models'">
                                            <shared-models-list></shared-models-list>
                                        </template>
                                        <template v-else-if="userFilterInfoData == 'models_history'">
                                            <used-history-models-list></used-history-models-list>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');
import carousel from 'vue-owl-carousel';
import createdModels from './created-models-list/index.vue';
import publicModels from './public-models/index.vue';
import sharedModels from './shared-models-list/index.vue';
import recentlyUsedModels from './recently-used-models/index.vue';
import usedHistoryModelsList from './used-models-history-list/index.vue';
export default {
    name: 'ai-dashboard',
    components: {
        carousel,
        'created-models': createdModels,
        'public-models': publicModels,
        'recently-used-Models': recentlyUsedModels,
        'shared-models-list': sharedModels,
        'used-history-models-list': usedHistoryModelsList
    },
    props: [],
    data() {
        return {
            countryList: [],
            userFilterInfoPopupState: false,
            userFilterInfoPopupStateClass: false,
            userFilterInfoData: null
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        userFiltersInfoPopupMethod(data) {
            this.userFilterInfoData = data
            $(window).scrollTop(0);
            this.userFilterInfoPopupState = true
            document.body.classList.add('body_right_scroll_remove')
            setTimeout(() => {
                this.userFilterInfoPopupStateClass = true
            }, 10);
        },
        clickedOutside() {
            this.userFilterInfoPopupStateClass = false
            setTimeout(() => {
                this.userFilterInfoPopupState = false
                document.body.classList.remove('body_right_scroll_remove')
                this.userFilterInfoData = ''
            }, 600);
        },
        getCountryFlag: function (countryCode, type) {
            if (countryCode == null) {
                countryCode = ''
            }
            let countryName = countryCode.toLowerCase()
            let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
            if (country && country.length > 0) {
                country = country[0]
                if (type == 'flag') {
                    country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
                } else {
                    country = country.name
                }
            } else {
                country = ''
            }
            return country;
        },
    },
    watch: {
    },
    beforeCreate: function () {
    },
    beforeRouteLeave: function (to, from, next) {
        $("body").removeClass("body_right_scroll_remove");
        next();
    },
}
</script>

<style lang="scss" scoped>
.lbil_admin_list_wrp {
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    letter-spacing: 1px;

    .top_brd {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .table {
        margin-bottom: 0;
        letter-spacing: 0.5px;
        color: #ffffff;

        thead th {
            border-bottom: 0;
            font-size: 16px;
            padding: 10px 5px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-transform: uppercase;
            border-top: 0px;

            &:first-child {
                padding-left: 0px;
            }

            &:last-child {
                padding-right: 0px;
            }
        }

        tbody {
            border-top: 0px;

            td {
                color: #ffffff;
                vertical-align: middle;
                padding: 12px 5px;
                font-size: 16px;
                border-color: rgba(255, 255, 255, 0.1);
                font-family: 'MyriadProRegular', 'Lato', sans-serif;

                &:first-child {
                    padding-left: 0px;
                }

                &:last-child {
                    padding-right: 0px;
                }
            }
        }

        a:hover {
            text-decoration: none;
        }

        .member_user_avtaar {
            display: inline-block;
            vertical-align: middle;

            img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                cursor: pointer;
            }
        }

        .member_user_info {
            display: inline-block;
            vertical-align: middle;
            width: calc(100% - 70px);
            margin-left: 10px;
        }

        .member_user_name {
            line-height: 1;
            font-size: 16px;
            color: #fff;
            display: block;
            cursor: pointer;

            a {
                color: #ffffff;
                text-decoration: none;
            }
        }

        .member_join_date {
            line-height: 1;
            font-size: 16px;
            color: #fff;
            display: block;
        }

        .member_user_email,
        .member_join_time {
            font-size: 15px;
            color: hsla(0, 0%, 100%, .5);
            white-space: pre-wrap;
            word-break: break-all;
            display: block;
        }

        .country-flag {
            width: 40px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
        }

        .btn-success.member_user_video_call_btn {
            font-size: 14px;
            padding: 3px 10px;
            border-radius: 50px;
            outline: none;
            box-shadow: none;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border: none;

            &:hover {
                background: #87cefa;
                color: #000000;
            }
        }
    }

    .main_heading {
        color: #ffffff;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .btn-primary {
        cursor: pointer;
        box-shadow: none !important;
        outline: none !important;

        &:hover {
            background: #87cefa;
            color: #000;
            border-color: #87cefa;
        }
    }

    .action_list {
        display: flex;
        margin: 0;
        justify-content: flex-end;
        padding-right: 3px;

        li {
            margin-left: 10px;

            &:first-child {
                margin-left: 0px;
            }

            .btn {
                padding: 2px 8px;
            }
        }
    }

    .lbil_doctor_info_modal {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 10001;
        min-height: 100dvh;
        width: 100%;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #333333;
        }
    }

    .lbil_doctor_info_modal_body {
        background: #000;
        width: 480px;
        margin: 0px auto;
        border-radius: 5px;
        padding: 20px 25px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .lbil_doctor_info_modal_wrp {
        display: table;
        width: 100%;
        height: 100%;
    }

    .lbil_doctor_info_modal_center {
        display: table-cell;
        vertical-align: middle;
    }

    .remove_data_task_header h2 {
        font-size: 18px;
        color: #ffffff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-align: center;
        margin: 0 0 30px;
    }

    .remove_yes_btn {
        font-size: 16px;
        background: rgba(255, 18, 18, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_yes_no {
        font-size: 16px;
        background: rgba(33, 228, 0, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        margin-left: 15px;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_data_task_btn {
        text-align: center;
    }

    .remove_data_task_btn {
        text-align: center;
    }

    .custom_round_switch {
        vertical-align: middle;
        margin-bottom: 0;
        margin-top: 3px;

        span {
            width: 20px;
            height: 20px;
            background: #da1b22;
            cursor: pointer;
            position: relative;
            display: inline-block;
            vertical-align: middle;
            border-radius: 50%;

            &:before {
                content: "";
                width: 10px;
                height: 10px;
                background: #fff;
                position: absolute;
                margin: auto;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                border-radius: 50%;
            }
        }
    }

    input[type=checkbox].checked+.custom_round_switch span {
        background: #36b04c;
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;
    }

    .load_more_btn:hover {
        color: #000 !important;
        background: #87cefa;
    }

    /* Toggle button styles */
    .onoffswitch {
        position: relative;
        width: 55px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }

    .onoffswitch-checkbox {
        display: none;
    }

    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        border: 0px solid #999999;
        border-radius: 20px;
    }

    .onoffswitch-inner {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }

    .onoffswitch-inner:before,
    .onoffswitch-inner:after {
        display: block;
        float: left;
        width: 50%;
        height: 25px;
        padding: 0;
        line-height: 25px;
        font-size: 13px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
    }

    .onoffswitch-inner:before {
        content: "";
        padding-left: 10px;
        background-color: #36B04C;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after {
        content: "";
        padding-right: 10px;
        background-color: #DA1B22;
        color: #FFFFFF;
        text-align: right;
    }

    .onoffswitch-switch {
        display: block;
        width: 17px;
        margin: 4px;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 31px;
        border: 0px solid #999999;
        border-radius: 13px;
        transition: all 0.3s ease-in 0s;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
        right: 0px;
    }

    .user_event_info {
        margin-top: 10px;
        display: block;

        .btn-primary {
            padding: 1px 8px;
            font-size: 13px;
            border-radius: 50px;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border: none;
            margin-right: 5px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }
        }
    }

    .user_not_connected_popup h3 {
        font-size: 20px;
        letter-spacing: 0;
        text-align: center;
    }

    .user_not_connected_popup .lbil_doctor_info_modal_body {
        padding: 50px 30px;
        margin: 15vh auto 0;
        width: 500px;
        text-align: center;
    }

    .connected_user_info_popup {
        .lbil_doctor_info_modal_body {
            width: 560px !important;
            position: relative;

            h3 {
                font-size: 22px;
                letter-spacing: 0;
                margin-bottom: 15px;
            }

            .connected_user_info_closed_icon {
                position: absolute;
                top: 5px;
                right: 8px;
                line-height: 1;

                .fa {
                    font-size: 20px;
                    color: red;
                    cursor: pointer;
                    transform: scale(1);
                    -webkit-transform: scale(1);
                    -moz-transform: scale(1);
                    transition: all ease 0.5s;

                    &:hover {
                        transform: scale(1.1);
                        -webkit-transform: scale(1.1);
                        -moz-transform: scale(1.1);
                    }
                }
            }
        }
    }

    .request_send_popup .form-control {
        background: rgba(255, 255, 255, 0.1) !important;
        border: none;
        color: #fff;
    }

    .request_send_popup h3 {
        font-size: 22px;
        letter-spacing: 0;
    }

    .badge {
        font-weight: normal;
        font-size: 13px;
        margin-bottom: 0px;
    }

    .request_send_popup .lbil_doctor_info_modal_body {
        text-align: center;
    }

    .add_user_btn {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        &:hover {
            background: #87cefa;
            color: #000;
            border-color: #87cefa;
        }
    }

    .delete_users_wrp h5 {
        margin: 0;
        font-size: 22px;
        padding: 15px 0;
        font-weight: 700;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-transform: uppercase;
        color: #fbfbd6;
    }

    .table_section_heading h5 {
        margin: 0;
        font-size: 22px;
        padding: 15px 0;
        font-weight: 700;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-transform: uppercase;
        color: #fbfbd6;
    }

    .all_user_list_wrp {
        padding: 12px 0;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        position: relative;

        .total_count_box {
            background: rgba(228, 233, 237, 0.1);
            padding: 0 0 0px 18px;
            border-radius: 5px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            cursor: pointer;
            color: #fff;
            height: 135px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }

            &:hover .count_icon path {
                fill: #000000;
            }

            &:hover .count_icon circle {
                fill: #000000;
            }

            &:hover .count_icon rect {
                fill: #000000;
            }

            &:hover .count_icon span {
                background: rgba(0, 0, 0, 0.1)
            }

            &.active {
                background: #87cefa;
                color: #000000;
            }

            &.active .count_icon path {
                fill: #000000;
            }

            &.active .count_icon circle {
                fill: #000000;
            }

            &.active .count_icon rect {
                fill: #000000;
            }

            &.active .count_icon span {
                background: rgba(255, 255, 255, 0.15);
            }

            &:hover .count_icon span .img-fluid {
                filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
            }

            &.active .count_icon span .img-fluid {
                filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
            }
        }

        .count_icon span {
            width: 70px;
            display: inline-block;
            height: 70px;
            background: hsla(0, 0%, 100%, .1);
            border-radius: 50%;
            text-align: center;
            line-height: 70px;

            .img-fluid {
                display: inline-block;
            }
        }

        .count_title_w_n {
            padding-left: 15px;
        }

        .count_number {
            display: block;
            font-size: 22px;
            font-weight: 600;
        }

        .count_title {
            font-size: 20px;
            text-transform: capitalize;
            line-height: 1;
        }

        .row .col-sm-3 {
            padding-left: 6px;
            padding-right: 6px;
        }

        .row {
            margin-left: -6px;
            margin-right: -6px;
        }

        .carousel_item {
            a {
                text-decoration: none;
            }
        }
    }

    .all_users_slider_arrow {
        position: absolute;
        z-index: 999;
        top: 50%;
        left: -21px;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);

        .fa {
            cursor: pointer;
            font-size: 42px;
            line-height: 28px;
            color: #ffc107;

            &:hover {
                color: #87cefa;
            }
        }

        &.member_slider_next {
            right: -21px;
            left: auto;
        }
    }
}

.new_user_info_checking {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    .lbil_doctor_info_modal_body {
        width: 580px !important;
        padding: 0px;
    }

    h3 {
        font-size: 28px;
        letter-spacing: 0;
        margin-bottom: 0;
    }

    .remove_data_task_header {
        padding: 15px;
        position: relative;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .new_user_info_checking_close {
        position: absolute;
        top: 15px;
        right: 10px;
        line-height: 1;

        .fa {
            font-size: 24px;
            color: red;
            cursor: pointer;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            -webkit-transition: all ease 0.5s;
            transition: all ease 0.5s;

            &:hover {
                color: #87cefa;
            }
        }
    }

    .new_user_info_checking_body li {
        font-size: 20px;
        padding: 15px 20px 0;
        display: flex;

        .new_user_info_key {
            color: #b1b1b1ee;
            display: inline-block;
            margin-right: 15px;
        }

        .new_user_info_val {
            display: inline-block;
            margin-left: 10px;
            color: #ffcd1d;

            .value_label:last-child {
                i {
                    display: none;
                }
            }
        }
    }

    .user_info_for_ai_task {
        text-align: center;

        .ai_user_info_avtaar .img-fluid {
            width: 100px;
            height: 100px;
            border-radius: 50%;
        }
    }
}

.filter_cat_box_list {
    .user_filters_list_link {
        text-decoration: none;
    }

    .user_filters_list_item {
        padding: 0 15px;
        border-radius: 20px;
        border: 1px solid rgba(123, 134, 138, .5);
        background: -webkit-gradient(linear, left top, left bottom, from(rgba(51, 51, 51, .6)), to(rgba(0, 0, 0, .75)));
        background: linear-gradient(180deg, rgba(51, 51, 51, .6), rgba(0, 0, 0, .75));
        text-align: center;
        margin: 15px 0;
        transition: all .3s ease;
        -webkit-transition: all .3s ease;
        -moz-transition: all ease .3s;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        cursor: pointer;
        -webkit-transform-origin: center center;
        transform-origin: center center;
        height: 175px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;

        &:hover {
            transform: scale(1.06);
            -webkit-transform: scale(1.06);
            -moz-transform: scale(1.06);
            border: 1px solid #769db4;
            background: rgba(144, 209, 249, .3);
        }

        .user_filters_title {
            color: #ffe400;
            font-size: 24px;
        }
    }
}

.user_filters_info_popup_main {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1001;

    .user_filters_info_popup {
        position: fixed;
        right: 0;
        top: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        transition: all .7s cubic-bezier(.42, 1.14, 1, 1);
        -webkit-transition: all .7s cubic-bezier(.42, 1.14, 1, 1);
        -moz-transition: all .7s cubic-bezier(.42, 1.14, 1, 1);
        transform: translateX(100%);
        -webkit-transform: translateX(100%);
        -moz-transform: translateX(100%);

        &.active {
            -webkit-transform: translateX(0);
            -moz-transform: translateX(0);
            transform: translateX(0);
            overflow: hidden auto;
        }
    }

    .user_filters_info_modal {
        background: rgba(0, 0, 0, 0.96);
        color: #fff;
        min-height: 100%;
        line-height: normal;
        font-size: 20px;

        .filter_subheading {
            font-size: 16px;
            color: #FFFDD0;
            margin: 0;
            padding-left: 15px;
            font-weight: normal;
            padding-top: 5px;
        }
    }

    .user_filters_info_close {
        text-align: right;
        padding: 10px 15px;

        .fa {
            color: #ffe400;
            font-size: 30px;
            cursor: pointer;

            &:hover {
                color: #87cefa;
            }
        }
    }
}

.carousel_item {
    a {
        text-decoration: none;
    }
}

.user_filters_info-heading {
    font-size: 28px;
    color: #ffd400;
    margin: 0;
    padding-left: 15px;
}
</style>